import { create } from 'zustand';
import api from '../../api';
import { RESPONSE } from '../../js/_constants';
import { type ModuleType } from '../../api/types';

interface ModuleTypesState {
  moduleTypes: ModuleType[];
  isModuleTypesLoading: boolean;
  getEditorialModuleTypes: () => Promise<any>;
}

const useModuleTypesStore = create<ModuleTypesState>()((set) => ({
  // Initial State
  moduleTypes: [],
  isModuleTypesLoading: false,

  // Async Action
  getEditorialModuleTypes: async () => {
    set({ isModuleTypesLoading: true });

    try {
      const response = await api.getModuleTypes();
      const editorialModules = response[RESPONSE.EXPAND_COLLECTION].filter(
        (module: { category: string }) => module.category === 'editorial'
      );

      set({ 
        moduleTypes: editorialModules, 
        isModuleTypesLoading: false 
      });
      
      return response;
    } catch (error) {
      set({ isModuleTypesLoading: false });
      throw error;
    }
  },
}));

export default useModuleTypesStore;
